import { useContext } from "react";
import PropTypes from "prop-types";

import { CompanyContext } from "../CompanyList/CompanyContext";
import BaseAwardText from "./BaseAwardText";

export const BaseServiceFlag = ({ classNames, icon }) => {
	const { companyIndex } = useContext(CompanyContext);

	return (
		<div className={classNames?.wrapper}>
			<div className={classNames?.flag}>
				<p className={classNames?.number}>{companyIndex + 1}</p>
			</div>

			<BaseAwardText icon={icon} classNames={classNames} />
		</div>
	);
};

export default BaseServiceFlag;

BaseServiceFlag.propTypes = {
	classNames: PropTypes.object,
	icon: PropTypes.element,
};
